import React from 'react';
import Navigation from './components/Navigation';
import Home from './components/Home';
import Footer from './components/Footer';
import NetworkBackground from './components/NetworkBackground';
import './App.css';

function App() {
    return (
        <div className="App">
            <NetworkBackground />
            <Navigation />
            <Home />
            <Footer />
        </div>
    );
}

export default App;
